module.exports = __webpack_public_path__ + "static/media/thumb-2.f392f613.jpg";